import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import TopicTitle from '../../../components/topicTitle';

class TopicReview extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        titleAd: PropTypes.object,
    };

    state = {
        len: 4,
        more: this.props.content.data.length > 4,
    };

    handleGetMore = () => {
        const {
            content: { data },
        } = this.props;

        this.setState({
            len: data.length,
            more: false,
        });
    };

    render() {
        const { len, more } = this.state;
        const { content, titleAd } = this.props;

        return (
            <div className={styles.topic_review_box}>
                {content.title !== '' ? (
                    <TopicTitle
                        id={content.specialId}
                        moduleIndex={content.moduleIndex}
                        title={content.title}
                        titleAd={titleAd}
                    />
                ) : (
                    ''
                )}
                <div className={styles.topic_review}>
                    {content.data.slice(0, len).map((item, index) => (
                        <div className={styles.timeline_evnets} key={index}>
                            <span />
                            <div className={styles.timeline_date}>{item.moment}</div>
                            <div className={styles.tiemline_text}>
                                {item.info.url ? (
                                    <a href={item.info.url}>{item.summary}</a>
                                ) : (
                                    <span>{item.summary}</span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
                {more ? (
                    <div className={styles.more} onClick={this.handleGetMore}>
                        <span>查看更多</span>
                        <span />
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(TopicReview);
